function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 15.586l5.707 5.707a1 1 0 0 1-1.414 1.414l-6-6A.997.997 0 0 1 15 16V9a1 1 0 1 1 2 0v6.586zM16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z"
});

var SvgTime = function SvgTime(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "aff8eb21e8edbd2038478a73f61d37ed.svg";
export { SvgTime as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/time.svg
// module id = null
// module chunks = 